import React from 'react'

import { Cluster } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { Button } from '@app/lib/inputs/Button/Button'
import { LineItem } from '@app/lib/layout/LineItem/LineItem'
import { Text } from '@app/lib/typography/Text/Text'

export type PaginationProps = {
  value: {
    total: number
    take: number
    skip: number
  }
  onChange: (value: { take: number; skip: number }) => void
}

export const Pagination = ({ value, onChange }: PaginationProps) => {
  const { formatMessage } = useIntl()

  const goToNext = () => {
    onChange({
      take: value.take,
      skip: value.skip + value.take
    })
  }

  const goToPrev = () => {
    onChange({
      take: value.take,
      skip: Math.max(0, value.skip - value.take)
    })
  }

  const showNext = value.skip + value.take < value.total
  const showPrev = value.skip - value.take >= 0

  return (
    <LineItem
      label={
        <Text color='primary' weight='bold'>
          {formatMessage(
            { id: 'Components.Lib.Pagination.TotalPages' },
            {
              pageIndex: Math.floor(value.skip / value.take) + 1,
              totalPages: Math.ceil(value.total / value.take) || 1
            }
          )}
        </Text>
      }
      actions={
        <Cluster>
          <Button onClick={goToPrev} disabled={!showPrev}>
            {formatMessage({ id: 'Components.Lib.Pagination.Previous' })}
          </Button>
          <Button onClick={goToNext} disabled={!showNext}>
            {formatMessage({ id: 'Components.Lib.Pagination.Next' })}
          </Button>
        </Cluster>
      }
    />
  )
}
